import React from "react";
import { Modal } from "react-bootstrap";
import PerfectScrollbar from "perfect-scrollbar";
import {
  wait,
  isMobile,
  isTablet,
  Event,
  __,
  hasClass,
  encode,
} from "../../../../Helper";
import C from "../../../../Constant";
import socket from "../../../../Socket";
import Messages from "./Messages";
import Submit from "./Submit";
import Country from "./Country";
import Rain from "./Rain";
import Rules from "./Rules";
import { RxCross2 } from "react-icons/rx";

const chatSideBarWidth = 400;

class Chat extends React.Component {
  constructor(props, toggleModal) {
    super(props);
    this.state = {
      show: true,
    };
  }

  componentDidMount() {
    if (isMobile() || isTablet()) {
      this.setState({ show: true });
    }
    window.addEventListener("resize", this.handleResize);

    wait(500).then(() => {
      this.handleResize();
    });

    Event.on("toggle_sidebar", () => {
      wait(100).then(() => {
        this.handleResize();
      });
    });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    const pageContent = document.querySelector("#page-content");
    const clientWidth =
      document.documentElement.clientWidth || document.body.clientWidth;
    const clientHeight =
      document.documentElement.clientHeight || document.body.clientHeight;

    if (pageContent !== null) {
      let space = 250;

      const leftSidebar = document.querySelector(".left-sidenav");
      const games = document.querySelectorAll(".game-image");

      if (hasClass(leftSidebar, "min") || !this.state.show) {
        space -= 170;

        if (!isMobile()) {
          games.forEach((g, i) => {
            if (g !== null) g.style.height = 160 + "px";
          });
        }
      } else {
        games.forEach((g, i) => {
          if (g !== null) g.style.height = 120 + "px";
        });
      }

      let pWidth =
        this.state.show === true
          ? clientWidth - (chatSideBarWidth + space)
          : clientWidth;

      if (pWidth < 960) {
        Event.emit("hide_games");
      }
    }

    if (!isMobile()) {
      this.setState({ height: clientHeight - 230 });
    } else {
      this.setState({ height: clientHeight - 210 });
    }
  };

  setSide = () => {
    let show = !this.state.show;

    wait(1).then(() => {
      this.handleResize();
    });

    Event.emit("toggle_chat", show);

    wait(200).then(() => {
      this.setState({ show: show });
      if (this.props.toggleModal) {
        this.props.toggleModal(); // Call toggleModal if passed as a prop
      }
    });
  };

  render() {
    const { t } = this.props;
    let margin;
    if (isMobile()) margin = "mt-1";

    let status = "left";
    if (this.state.show) status = "right";

    return (
      <>
        {/* <button onClick={this.setSide} className={"btn rounded notif-btn tbtn btn-ocol px-1 py-1 " + margin}>
                    <i className={`mdi mdi-comment-arrow-${status} font-30`} />
                </button> */}

        {this.state.show && (
          <Content t={t} height={this.state.height} setSide={this.setSide} />
        )}
      </>
    );
  }
}

class Content extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      width: chatSideBarWidth + "px",
      effect: "slideInRight",
    };
  }

  componentDidMount() {
    loadScroll();
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
    Event.on("toggle_chat", (show) => {
      if (!show) this.setState({ effect: "slideOutRight" });
      else this.setState({ effect: "slideInRight" });
    });
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.handleResize);
  }

  handleResize = () => {
    if (isMobile()) {
      this.setState({ width: "100%" });
    } else {
      this.setState({ width: chatSideBarWidth + "px" });
    }
  };

  render() {
    const { t, setSide } = this.props;
    return (
      <>
        <div
          className={
            "main-menu-inner  animated chat-body-bc" + this.state.effect
          }
          style={{ zIndex: 9999 }}
        >
          <div className="menu-body slimscroll">
            <div className="main-icon-menu-pane active">
              {/* <div className="title-box" style={{backgroundImage:"linear-gradient(90deg, #14b497, #a0bdb8)" , boxShadow:"inset 0px -2px 0px rgb(255, 168, 0)"}}> */}
              <div
                className="title-box"
                style={{
                  backgroundImage:
                    "linear-gradient(90deg, rgb(46 213 91), rgb(172 201 182))",
                  boxShadow:
                    "0 0 12px  rgb(46 213 91), 0 -2px  rgb(46 213 91) inset",
                }}
              >
                <h6
                  className="menu-title"
                  style={{
                    textAlign: "center",
                    alignItems: "center",
                    display: "flex",
                    height: "50px",
                    justifyContent: "space-between",
                  }}
                >
                  <Country t={t} />
                  <div onClick={() => setSide()} className="chat-box-close-btn">
                    <RxCross2
                      style={{
                        color: "black",
                        fontSize: "17px",
                        cursor: "pointer",
                        fontWeight: "900",
                      }}
                    />
                  </div>
                  {/* <Rules t={t} setSide={setSide}/> */}
                  {/* <Rain t={t} /> */}
                </h6>
              </div>
              <div
                id="messages"
                style={{
                  height: "calc(100vh - 50px )",
                  backgroundColor: "rgb(2 31 28)",
                  paddingBottom: "120px",
                }}
              >
                <Messages t={t} />
              </div>
              <Submit t={t} />
            </div>
          </div>
        </div>
      </>
    );
  }
}

function loadScroll() {
  if (document.getElementById("messages") !== null) {
    let ps = new PerfectScrollbar("#messages", {
      wheelSpeed: 1,
      suppressScrollX: true,
      wheelPropagation: true,
      minScrollbarLength: 2,
    });
    ps.update();
  }
}

export default Chat;
